import { Check } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

const TEXTURE =
  "https://images.pexels.com/photos/36616863/pexels-photo-36616863.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export const Certification = () => {
  const { t } = useLang();
  const c = t.certification;

  return (
    <section id="documentation" className="relative bg-nero-black text-white overflow-hidden" data-testid="certification">
      <img src={TEXTURE} alt="" className="absolute inset-0 w-full h-full object-cover opacity-[0.12]" />
      <div className="absolute inset-0 grain opacity-[0.05]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <Overline index="05" dark>{c.label}</Overline>
              <h2 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight leading-[1.05]">
                {c.title}
              </h2>
              <p className="mt-6 font-body text-base lg:text-lg leading-relaxed text-white/55">{c.text}</p>

              <div className="mt-10 border-t border-l border-white/15">
                {c.standards.map((s, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between border-b border-r border-white/15 px-5 py-5"
                    data-testid={`standard-${i}`}
                  >
                    <span className="font-body text-sm text-white/70">{s.name}</span>
                    <span className="font-heading text-sm font-semibold text-nero-green shrink-0 pl-4">{s.abbr}</span>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal delay={0.1}>
              <div className="border border-white/15 bg-white/[0.03] backdrop-blur-sm p-8 lg:p-10">
                <h3 className="font-body text-xs uppercase tracking-[0.22em] font-semibold text-white/50">
                  {c.mrvTitle}
                </h3>
                <ul className="mt-7 grid sm:grid-cols-2 gap-x-8">
                  {c.mrv.map((m, i) => (
                    <li
                      key={i}
                      className="flex items-start gap-3 py-3.5 border-b border-white/10"
                      data-testid={`mrv-item-${i}`}
                    >
                      <Check className="mt-0.5 h-4 w-4 text-nero-green shrink-0" strokeWidth={2.5} />
                      <span className="font-body text-sm text-white/75">{m}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
